import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import BEMHelper from '@ynap/bem-helper'
import Notification from '@ynap/notification'
import { getOrderReviewStep, cartActions } from 'app/state/cart-state'
import Loading from '../Loading/Loading'
import { OverlayWithToggle } from '@ynap/overlay'
import SidebarHeader from './SidebarHeader'
import Price from '../Price/Price'
import { LineItemGroup, LineItem } from '@ynap/line-item'
import Totals from '@ynap/totals'
import ImmutablesProvider from '@ynap/immutables-provider'

const bem = new BEMHelper('Sidebar')

const Sidebar = (props) => {
    const {
        messages,
        lineItems = [],
        totals,
        sidebar,
        checkoutNotification,
        config,
        DDPCountry,
        DDPIncCountry,
        locale,
        showTaxAbove,
        remoteItems,
        localItems,
        isPostSplit,
    } = props

    const totalQuantity = lineItems.reduce((acc, { quantity }) => acc + quantity, 0)
    const toggleComponentProps = { messages, lineItems, totals, totalQuantity }

    const renderLineItems = (lineItems) =>
        lineItems.map((item) => {
            return <LineItem key={item.partNumber} messages={messages} className={bem('item')} priceComponent={Price} {...item} showUsTaxUi={showTaxAbove} />
        })

    const renderDetails = () => {
        return (
            <div className={bem('wrapper')}>
                {lineItems.length === 0 ? (
                    <Loading message={'Loading'} className={bem('loading')} />
                ) : (
                    <>
                        <section className={bem()}>
                            <div className={bem('itemsListing')}>
                                {checkoutNotification ? (
                                    <Notification
                                        className={bem('checkout-notification')}
                                        type={checkoutNotification.type}
                                        message={checkoutNotification.message}
                                    />
                                ) : null}
                                <LineItemGroup className={bem('lineItemGroup')}>
                                    {localItems && renderLineItems(localItems)}
                                    {isPostSplit && <li className={bem('postshipDivider')}>{messages.basket.jit.postship?.()}</li>}
                                    {renderLineItems(remoteItems)}
                                </LineItemGroup>
                            </div>
                            <footer className={bem('footer')}>
                                {totals ? (
                                    <Totals
                                        className={bem('totals')}
                                        {...totals}
                                        messages={messages}
                                        enablePromotions
                                        rewards={totals.rewards || []}
                                        taxDutyInfo={totals.dutyType === 'DDU' ? totals.taxDutyInfo : undefined}
                                        ddpInfo={DDPCountry || DDPIncCountry}
                                        showUsTaxUi={showTaxAbove}
                                        isCheckoutLayout={true}
                                        displaySavingsExplanation={locale?.country !== 'US' && config?.head?.omnibusROWEnabled ? true : false}
                                    />
                                ) : null}
                            </footer>
                        </section>
                    </>
                )}
            </div>
        )
    }

    return (
        sidebar && (
            <ImmutablesProvider value={{ config }}>
                <div className={bem('sidebarDesktop')}>
                    <div className={bem('header')}>
                        <header>
                            <h1 className={bem('title')}>{messages?.orderReview?.sidebarTitle({ quantity: totalQuantity })}</h1>
                        </header>
                    </div>
                    {renderDetails()}
                </div>
                <OverlayWithToggle toggleComponent={SidebarHeader} toggleComponentProps={toggleComponentProps} className={bem('sidebarMobile')}>
                    {renderDetails()}
                </OverlayWithToggle>
            </ImmutablesProvider>
        )
    )
}
Sidebar.propTypes = {
    sidebar: PropTypes.bool,
    lineItems: PropTypes.arrayOf(PropTypes.object),
    totals: PropTypes.shape({
        packaging: PropTypes.string,
        currency: PropTypes.string.isRequired,
        itemTotal: PropTypes.string,
        shipping: PropTypes.string,
        total: PropTypes.string.isRequired,
        promotions: PropTypes.array,
        savingsTotal: PropTypes.string,
    }),
    messages: PropTypes.shape({
        orderReview: PropTypes.shape({
            sidebarTitle: PropTypes.func,
        }),
    }).isRequired,
}

export default connect((state, props) => ({ ...getOrderReviewStep(state, props), config: state.config }), cartActions)(Sidebar)
